export interface FieldTypeObject {
  id: number;
  value: "text" | "number" | "select" | "radio" | "checkbox" | "date" | "datetime" | "decimal";
  label: string;
}

export const FIELD_TYPES: Record<string, FieldTypeObject> = {
  TEXT:      { id: 1, value: "text",     label: "Texte" },
  NUMBER:    { id: 2, value: "number",   label: "Nombre" },
  SELECT:    { id: 3, value: "select",   label: "Select" },
  RADIO:     { id: 4, value: "radio",    label: "Radio" },
  CHECKBOX:  { id: 5, value: "checkbox", label: "Checkbox" },
  DATE:      { id: 6, value: "date",     label: "Date" },
  DATETIME:  { id: 7, value: "datetime", label: "Date et Heure" },
  DECIMAL:   { id: 8, value: "decimal",  label: "Décimal" },
};

export const FIELD_TYPES_LIST = Object.values(FIELD_TYPES);

export function getFieldTypeById(id: number) {
  return FIELD_TYPES_LIST.find(t => t.id === id);
}

export function getFieldTypeByValue(v: string) {
  return FIELD_TYPES_LIST.find(t => t.value === v);
}